import React, { useEffect, useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import LeadForm from "./LeadForm"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Loader from "components/Loader/Loader"
import Swal from "sweetalert2"
import Configs from "../../config"
import { useNavigate } from "react-router-dom"

const AddLead = () => {
  document.title = "Add Lead | Vintage Infra Equipment Sol PVT LTD"
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({})
  const [users, setUsers] = useState([])
  const [leadSources, setLeadSources] = useState([])

  useEffect(() => {
    fetchUsers()
  }, [])

  async function fetchUsers() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setUsers(APIdata?.data.filter(user => user.status))
    }

    const APIdata1 = await fetchData(setLoading, "lead-source")
    if (APIdata1?.success) {
      setLeadSources(APIdata1?.data)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const APIdata = await FetchPostData(setLoading, "leads", formData)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Lead Added Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      navigate(`${Configs.appurl}leads`)
    } else {
      Swal.fire({
        title: "Error Adding Lead",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Leads Management" breadcrumbItem="Add Lead" />

      <LeadForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        users={users}
        leadSources={leadSources}
        mode="add"
      />
    </div>
  )
}

export default AddLead
